import request from '@/axios'

export function  calenderNoteList (payload, customer_id) {
  return request({
    url: `V1/ClientUser/schedule/note/list/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function  fetchResheduleLog (customer_id, payload) {
  return request({
    url: `V1/ClientUser/schedule/reschedule/logs/get/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function  fetchResheduleSlot (customer_id, payload) {
  return request({
    url: `V1/ClientUser/schedule/reschedule/available/slots/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

export function  confirmRescheduleApi (customer_id, payload) {
  return request({
    url: `V1/ClientUser/schedule/reschedule/${customer_id}`,
    method: 'POST',
    data:payload
  })
}


export function  fetchDateRange (customer_id, payload) {
  return request({
    url: `V1/ClientUser/schedule/course/date_range/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

export function  checkOwnStatus (customer_id, payload) {
  return request({
    url: `V1/ClientUser/schedule/attendance/check/own/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

export function notesDownloadApi (customer_id, note_id) {
  return request({
    url: `V1/ClientUser/schedule/note/download/${customer_id}/${note_id}`,
    method: 'GET'
  })
}

export function cancelSchedulerApi (customer_id, payload) {
  return request({
    url:`ClientUser/course/schedule/cancel/${customer_id}`,
    method:'POST',
    data:payload
  })
}